<script>
    export let checked = false;
    export let onSwitchClick = () => {};
</script>

<style>
    .switch {
        position: relative;
        display: inline-block;
        width: 40px;
        height: 15px;
        background: #E0E0E0 0% 0% no-repeat padding-box;
        border-radius: 40px;
        opacity: 1;
    }

    .switch input {
        opacity: 0;
        width: 0;
        height: 0;
    }

    .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        -webkit-transition: 0.4s;
        transition: 0.4s;
        background: #E0E0E0 0 0 no-repeat padding-box;
        border-radius: 40px;
        opacity: 1;
    }

    .slider:before {
        position: absolute;
        content: "";
        height: 20px;
        width: 20px;
        left: -1px;
        bottom: -3px;
        -webkit-transition: 0.4s;
        transition: 0.4s;
        border-radius: 50%;
        background: #FFFFFF 0 0 no-repeat padding-box;
        box-shadow: -2px 4px 10px #203A7E1A;
        border: 0.25px solid #D6E0FB;
        opacity: 1;
    }

    input:checked + .slider {
        background-color: #2196f3;
    }

    input:checked + .slider {
        box-shadow: 0 0 1px #2196f3;
    }

    input:checked + .slider:before {
        -webkit-transform: translateX(26px);
        -ms-transform: translateX(26px);
        transform: translateX(26px);
    }
</style>

<label class="switch" on:click={onSwitchClick(!checked)}>
    <input type="checkbox" bind:checked />
    <span class="slider" />
</label>
